import { ArrowRight, Lock, UserRound, Target, Search, MessageSquareMore, Clock } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { QUICK_FIELDS } from "@/data/content";
import { useDiagnostic } from "./DiagnosticContext";
import { Reveal } from "./Reveal";

const ICONS = { user: UserRound, target: Target, search: Search, message: MessageSquareMore, clock: Clock };

export const ReadinessCard = () => {
  const { answers, setAnswer, open } = useDiagnostic();
  return (
    <div className="space-y-4 lg:sticky lg:top-[88px]">
      <Reveal>
        <div data-testid="readiness-form-card" className="rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_30px_60px_-36px_rgba(11,27,51,0.45)]">
          <h2 className="font-display text-[24px] font-bold leading-[1.12] tracking-tight text-[#0B1B33]">Start with a 5-minute readiness check</h2>
          <p className="mt-2 text-[14px] text-slate-600">Your answers help us suggest the right starting point.</p>
          <div className="mt-5 space-y-2.5">
            {QUICK_FIELDS.map((f) => {
              const Icon = ICONS[f.icon];
              return (
                <Select key={f.key} value={answers[f.key] || ""} onValueChange={(v) => setAnswer(f.key, v)}>
                  <SelectTrigger data-testid={`quick-select-${f.key}`} className="h-12 w-full overflow-hidden rounded-lg border-slate-300 [&>span]:!flex [&>span]:min-w-0 bg-white text-left text-[14px] text-slate-700 transition-colors hover:border-[#14B8A6] focus:ring-[#14B8A6]">
                    <span className="flex min-w-0 items-center gap-3">
                      <Icon className="h-4 w-4 shrink-0 text-slate-600" />
                      <span className="truncate"><SelectValue placeholder={f.label} /></span>
                    </span>
                  </SelectTrigger>
                  <SelectContent className="max-w-[340px]" data-lenis-prevent>
                    {f.options.map((o) => <SelectItem key={o} value={o} className="text-[13px]">{o}</SelectItem>)}
                  </SelectContent>
                </Select>
              );
            })}
          </div>
          <button data-testid="submit-readiness-btn" onClick={() => open()}
            className="btn-teal mt-5 flex w-full items-center justify-center gap-2 rounded-xl py-4 text-[18px] font-semibold">
            Start My Diagnostic <ArrowRight className="arrow h-5 w-5" />
          </button>
          <p className="mt-4 flex gap-3 px-2 text-[13px] text-slate-600">
            <Lock className="h-4 w-4 shrink-0 text-[#0B1B33]" /> Your answers are private and used only to tailor guidance.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div data-testid="no-placement-note" className="rounded-2xl border border-slate-200 bg-white p-5 text-[14px] text-slate-700">
          <p className="text-[13px] text-slate-600">No job-placement services are offered.</p>
          This is a practical learning cohort, not a promise of employment or outcomes.
        </div>
      </Reveal>
    </div>
  );
};
